export const LOCAL_STORAGE_AUTH_TOKEN = 'petis_partner_auth_token'
export const LOCAL_STORAGE_LICENSING_ID = 'petis_partner_licensing_id'
